import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_4 = {
  key: 1,
  class: "we-nodata",
  style: {"margin-right":"2px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { style: {"margin-left":"15px"} }, "添加", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加新联系人")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关联已有联系人")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    gutter: 20,
    type: "flex",
    style: {"flex-wrap":"wrap"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "对账联系人" }, {
            default: _withCtx(() => [
              (_ctx.contract.person_list.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contract.person_list, (person, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBillingEmailIcon = true)),
                        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBillingEmailIcon = false))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(person.name) + " - " + _toDisplayString(person.email), 1),
                        _withDirectives(_createElementVNode("a", {
                          style: {"cursor":"pointer","color":"#4885ed"},
                          iconName: "CloseCircleFilled",
                          onClick: ($event: any) => (_ctx.removePerson(person))
                        }, " 移除 ", 8, _hoisted_2), [
                          [_vShow, _ctx.showBillingEmailIcon]
                        ]),
                        (i < _ctx.contract.person_list.length - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, ","))
                          : _createCommentVNode("", true)
                      ], 32))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "—")),
              (_ctx.canEditPerson)
                ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 2 }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, {
                            key: "1",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addPerson()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, {
                            key: "2",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.attachPerson()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}